import { render, staticRenderFns } from "./instanceDatabase.vue?vue&type=template&id=1f6cf65c&"
import script from "./instanceDatabase.vue?vue&type=script&lang=js&"
export * from "./instanceDatabase.vue?vue&type=script&lang=js&"
import style0 from "./instanceDatabase.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports